/* eslint-disable header/header */
export const name = "msal";
export const version = "1.4.11";
